/**
 * CORE-1375 — материал в библиотеке видео-практик может оказаться без
 * видеодорожки: запись комнаты без камеры, продвинутая в «Медиа», приходит как
 * `contentType: 'practice'` с валидным файлом, у которого только звук. Бэк
 * этого не помечает, так что единственное место, где факт виден — сам
 * элемент: после `loadedmetadata` у такого `<video>` кадр 0 × 0 при
 * `readyState = 4` и `error = null`. Рисовать его — значит показывать чёрный
 * прямоугольник, неотличимый от «видео не загрузилось».
 *
 * Правило вынесено из хука, чтобы проверяться без DOM.
 */
export interface VideoFrameDims {
    videoWidth: number;
    videoHeight: number;
}

/** Есть ли у элемента кадр — по спецификации размеры известны на `loadedmetadata`. */
export function hasVideoFrame(dims: VideoFrameDims): boolean {
    return dims.videoWidth > 0 && dims.videoHeight > 0;
}
